/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSparkWalletBalance} from '../api'

 export const useQueryGetSparkWalletBalance = createReactQueryHook('getSparkWalletBalance', getSparkWalletBalance)
